import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["settlementCurrencyCode", "settlementCurrencyValue"];
import { memo } from 'react';
import I18n from 'I18n';
import PropertyInputHomeCurrencyV2 from './PropertyInputHomeCurrencyV2';
import { useFormattedCurrencyDisplay } from '../v2/hooks/useFormattedCurrencyDisplay';
import { useAdditionalPropertyValues } from '../v2/hooks/useAdditionalPropertyValues';
import { useProperty } from '../v2/hooks/useProperty';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { parseNumericValue } from '../utils/parseNumericValue';
import emptyFunction from 'react-utils/emptyFunction';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import TextInputAdapter from '../adapters/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const ReadonlyCurrencyConversionProperty = _ref => {
  let {
      settlementCurrencyCode,
      settlementCurrencyValue
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const formattedCurrencyDisplay = useFormattedCurrencyDisplay();
  const formattedSettlementCurrencyDisplay = useFormattedCurrencyDisplay({
    defaultValue: settlementCurrencyValue,
    defaultCurrencyCode: settlementCurrencyCode
  });
  const displayValue = `${I18n.formatIntlCurrency(formattedCurrencyDisplay.currencyValue, {
    currencyCode: formattedCurrencyDisplay.currencyCode
  })} (${I18n.formatIntlCurrency(formattedSettlementCurrencyDisplay.currencyValue, {
    currencyCode: formattedSettlementCurrencyDisplay.currencyCode
  })})`;
  return /*#__PURE__*/_jsx(TextInputAdapter, Object.assign({}, getTransferrableProps(props), {
    value: displayValue,
    onChange: emptyFunction,
    readOnly: true
  }));
};
const PropertyInputSettlementCurrency = props => {
  useComponentMountMetric('PropertyInputSettlementCurrency');
  const propertyValue = usePropertyValue();
  const property = useProperty();
  const {
    data: settlementCurrencyPropertyValues
  } = useAdditionalPropertyValues({
    exchangeRate: 'hs_presentment_to_settlement_currency_exchange_rate',
    settlementCurrencyValue: `${property.name}_in_settlement_currency`,
    settlementCurrencyCode: 'hs_settlement_currency_code'
  });
  if (props.readOnly && propertyValue && settlementCurrencyPropertyValues !== null && settlementCurrencyPropertyValues !== void 0 && settlementCurrencyPropertyValues.exchangeRate && settlementCurrencyPropertyValues !== null && settlementCurrencyPropertyValues !== void 0 && settlementCurrencyPropertyValues.settlementCurrencyValue && settlementCurrencyPropertyValues !== null && settlementCurrencyPropertyValues !== void 0 && settlementCurrencyPropertyValues.settlementCurrencyCode && parseNumericValue(settlementCurrencyPropertyValues.settlementCurrencyValue) !== parseNumericValue(propertyValue)) {
    // Has all the necessary values to display the settlement currency in brackets
    return /*#__PURE__*/_jsx(ReadonlyCurrencyConversionProperty, Object.assign({}, props, {
      settlementCurrencyValue: settlementCurrencyPropertyValues.settlementCurrencyValue,
      settlementCurrencyCode: settlementCurrencyPropertyValues.settlementCurrencyCode
    }));
  }
  return /*#__PURE__*/_jsx(PropertyInputHomeCurrencyV2, Object.assign({}, props));
};
export default /*#__PURE__*/memo(PropertyInputSettlementCurrency);